import { useEffect, useRef } from 'react'

const usePrevious = <V>(value: V): V | undefined => {
  const ref = useRef<V>(undefined)
  useEffect(() => {
    ref.current = value
  }, [value])
  return ref.current
}

export default usePrevious
